
import axios from "axios";
import Message from "portal-component/packages/message/";
import Promise from "es6-promise";
// import store from "../store";

function getQueryString(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  var r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return unescape(r[2]);
  }
  return null;
}
var token=localStorage.getItem("token")
 export var token = 'eyJhbGciOiJSUzUxMiJ9.eyJzdWIiOiIyMDAxMDIwMDQ5IiwiaXNzIjoidWlzLnBhYXMubndwdS5lZHUuY24iLCJBVFRSX2lkZW50aXR5VHlwZUlkIjoiVDAxIiwiQVRUUl9hY2NvdW50SWQiOiIyMDAxMDIwMDQ5IiwiQVRUUl91c2VySWQiOiIyMDAxMDIwMDQ5IiwiQVRUUl9uYW1lIjoi6buE5pmT5rOiIiwiQVRUUl9pZGVudGl0eVR5cGVDb2RlIjoiVDAxIiwiQVRUUl9pZGVudGl0eVR5cGVOYW1lIjoi5pWZ6IGM5belIiwiQVRUUl9vcmdhbml6YXRpb25OYW1lIjoi5L-h5oGv5YyW5bu66K6-5LiO566h55CG5aSEIiwiQVRUUl91c2VyTmFtZSI6Ium7hOaZk-azoiIsImV4cCI6MTYyNzM1MDc2OCwiQVRUUl9vcmdhbml6YXRpb25JZCI6IjAyMjYwIiwiaWF0IjoxNjI2MTQxMTY4LCJqdGkiOiJJRC1Ub2tlbi0yNzYtZDQzdm1sMjBxTXQ3eUNmdmZWZ1FWY0ZJV1pRdnN1LTAiLCJyZXEiOiLpl6jmiLd2Nua1i-ivleWJjeerryIsIkFUVFJfb3JnYW5pemF0aW9uQ29kZSI6IjAyMjYwIn0.iPchWwY2DcpsLIXWCsb-qCLNhtk3l-6i7FweQw5qF95xkS-n2GBS_xdsFmIQAIfAzylOiaRTS_nPGhWWl7xHEKa_8S_oKM1OSLhy78xffmSUSG1T-h0QDlhc995JfpmzW0qkial28jfca0SCNOjRHuT3-RB4BaaHULHuPD-j5JI'
if (!token) {
	token = getQueryString('token');
	window.localStorage.setItem('token', token);
}

// create an axios instance
const service = axios.create({
  baseURL: "", // url = base url + request url
  withCredentials: false, // send cookies when cross-domain requests
  timeout: 1000 * 60 // request timeout
});

// request interceptor
service.interceptors.request.use(
  config => {
    // let token = `${store.state.user.token}`; // 主题传入
    // ToDo 这边token不要加了
    // let token = window.localStorage.token; // 组件测试手动添加，防止代码冲突；
    // token = 'eyJhbGciOiJSUzUxMiJ9.eyJzdWIiOiJjempUZXN0IiwiQVRUUl90eXBlTmFtZSI6IueuoeeQhiIsIkFUVFJfc3NvQWNjb3VudCI6ImN6alRlc3QiLCJBVFRSX2RlcHROYW1lIjoi6KGM5pS_5py65p6EIiwiaXNzIjoic3Vwd2lzZG9tIiwiQVRUUl9tb2JpbGUiOiIiLCJBVFRSX2RuIjoiIiwiQVRUUl9pZGVudGl0eVR5cGVJZCI6IjEiLCJBVFRSX3VzZXJJZCI6IjkzYjVjYzgwZDJmZjExZWE1NmIyMzgxODc4ZTYwNzhjIiwiQVRUUl9zdHVkZW50Tm8iOiIiLCJBVFRSX2RlcHRDb2RlIjoiMCIsIkFUVFJfaWRlbnRpdHlUeXBlQ29kZSI6ImFkbWluIiwiQVRUUl9lbWFpbCI6IiIsIkFUVFJfbmljayI6IiIsImV4cCI6MTU5NjIxMTIxNSwiaWF0IjoxNTk2MTgyNDE1LCJqdGkiOiJJRC1Ub2tlbi00NzUwLVh3SGxVd25TUm5mLURoejNIV1Q3Rjl4cmdoSktvLVR6IiwicmVxIjpudWxsLCJBVFRSX29yZ2FuaXphdGlvbkNvZGUiOiIwIiwiQVRUUl91c2VyTm8iOiI5M2I1Y2M4MWQyZmYxMWVhNTZiMjM4MTg3OGU2MDc4YyIsIkFUVFJfaWRlbnRpdHkiOiLnrqHnkIYiLCJBVFRSX2lkQ2FyZCI6IiIsIkFUVFJfdHlwZSI6ImFkbWluIiwiQVRUUl9kaWNPcmdJZCI6IjAiLCJBVFRSX29yZ2FuaXphdGlvbiI6IuihjOaUv-acuuaehCIsIkFUVFJfc3RhZmZObyI6IiIsIkFUVFJfYWNjb3VudElkIjoiOTNmZTZlNDBkMmZmMTFlYTU2YjIzODE4NzhlNjA3OGMiLCJBVFRSX25hbWUiOiLpmYjlrZDlkJsiLCJBVFRSX2xvY2FsQWNjb3VudCI6ImN6alRlc3QiLCJBVFRSX3RlbCI6IiIsIkFUVFJfcmVtYXJrIjoiIiwiQVRUUl9pZGVudGl0eVR5cGVOYW1lIjoi566h55CGIiwiQVRUUl90eXBlQ29kZSI6ImFkbWluIiwiQVRUUl9vcmdhbml6YXRpb25OYW1lIjoi6KGM5pS_5py65p6EIiwiQVRUUl9vcmdhbml6YXRpb25JZCI6IjAifQ.DPaUnR3boOT4sIaQX7T10IVplFEL_mk09ZiBOxW8q83p43oZMVqigwdUp2VocWpUpGXa_Qn3venMpEA22bRzkHI9TEo2E4vRjyEEnYXDpjNQC0SC-9ekINt8Am3XDEykFN97Ve_oPZPFMEe_zb-aFL7-Z3wRHoGdUP0UOb0OxWsHfzPt06oo2Mc39Q30JmitfmdQZYZUMv4weMjX-EiYhgV1n8Jv86qpWqNzrESW6kGrJ9dypHaP-wEzuIa2sfdWtc6muWg9li-U9dw_jOstEQxvocSFA8fRx_k68pZNm8N_iDtS9SrD49xaVG_7Xu12UF7FtNkAAeesc4PT3zT4XQ';
    // config.headers["Authorization"] = 'Bearer ' + token;
    // config.headers["X-Device-Info"] = "PC";
    // config.headers["X-Terminal-Info"] = "PC";
    // config.headers["X-Id-Token"] = token;
    // config.headers["X-FORWARD-ID-TOKEN"] = token;
    if (config.additionalHeaders)config.headers = {...config.headers, ...config.additionalHeaders};
    switch (config.headerType) {
      // 门户请求头
      case "portal":
        config.headers["X-Device-Info"] = "PC";
        config.headers["X-Terminal-Info"] = "PC";
        config.headers["X-Id-Token"] = token;
        break;
      // 游客请求头
      case "open":
        config.headers["X-Device-Info"] = "PC";
        config.headers["X-Terminal-Info"] = "PC";
        break;
      // 消息请求头
      case "message":
        config.headers["X-Id-Token"] = token;
        break;
      // 事务请求头
      case "task":
        config.headers["Authorization"] = token;
        break;
      // 认证请求头
      case "cas":
        config.headers["X-Id-Token"] = token;
        break;
      // 表单、流程、打印模版设计
      case "forward":
        config.headers["X-FORWARD-ID-TOKEN"] = token;
        break;
      // 部门组织组、群组、角色
      case "admin":
        config.headers["Authorization"] = `Bearer ${token}`;
        break;
      case "personal-center":
        config.headers["authorization"] = `Bearer ${token}`;
        break;
      // 默认游客请求头
      default:
        config.headers["X-Device-Info"] = "PC";
        config.headers["X-Terminal-Info"] = "PC";
        break;
    }

    // get参数编码
    if (config.method === "get" && config.params) {
      let url = config.url;
      url += "?";
      let keys = Object.keys(config.params);
      for (let key of keys) {
        if (Array.isArray(config.params[key])) {
          config.params[key].forEach(item=>{
            url += `${encodeURIComponent(key)}=${encodeURIComponent(
                item
            )}&`;
          });
        } else if (config.params[key] !== undefined && config.params[key] !== "") {
          url += `${encodeURIComponent(key)}=${encodeURIComponent(
            config.params[key]
          )}&`;
        }
      }
      url = url.substring(0, url.length - 1);
      config.params = {};
      config.url = url;
    }
    return config;
  },
  error => {// for debug
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  response => {
    if (response.data.code === -1001) {
      // store.dispatch("signOut").then(() => {
      //   window.location.href =
      //     process.env.VUE_APP_CAS_URL +
      //     encodeURIComponent(process.env.VUE_APP_URL);
      // });
    } else if (response.status !== 200) {
      Message.error(response.message || "Error");
    }
    // Cannot read property 'data' of undefined
    return response.data;
  },
  error => {
    if (error.response.status === -1001) {
      // store.dispatch("signOut").then(() => {
      //   window.location.href =
      //     process.env.VUE_APP_CAS_URL +
      //     encodeURIComponent(process.env.VUE_APP_URL);
      // });
    } else if (error.response.status === 403) {
		window.localStorage.removeItem('token');
		//window.location.href = "https://admin-center.paas.newcapec.cn/jwt/cas/login?redirect_uri=" + location.origin + location.pathname + '&state=user';
	} else {
      if (!error.response.config.hideMessage) {
        Message({
          message: error.response.data.message,
          type: "error",
          duration: 5 * 1000
        });
      }
    }
    return Promise.reject(error);
  }
);

export default service;
